import React from "react";
import { Main } from "../components/sections/orders/Main";

export const Orders = () => {
  return <Main />;
};
